
import { ProductModel } from './productModel';

export class DeviceModel {
  deviceId: number;
  userDeviceId: number;
  deviceName: string;
  manufacturer: string;
  isOwner: boolean;
  birthDate: Date;
  isMale: boolean;
  deviceOS: string;
  mainBoardName: string;
  lastUsedIP: string;
  isTheft: boolean;
  lastUsedIpLogTime: Date;
  prosecutable: boolean;
  systemType: string;
  products: ProductModel[]=[];
  productExpirationDate: Date = null;
  servicePack: string = null;
  osVersion: string = null;
}


